var map = {
	"./April2025": [
		92234,
		9,
		11216,
		79351,
		92234
	],
	"./April2025/": [
		92234,
		9,
		11216,
		79351,
		92234
	],
	"./April2025/index": [
		92234,
		9,
		11216,
		79351,
		92234
	],
	"./April2025/index.tsx": [
		92234,
		9,
		11216,
		79351,
		92234
	],
	"./AviatorUp": [
		33537,
		9,
		11216,
		79351,
		77598,
		33537
	],
	"./AviatorUp/": [
		33537,
		9,
		11216,
		79351,
		77598,
		33537
	],
	"./AviatorUp/animation/aviatorFirstClick": [
		18819,
		3,
		18819
	],
	"./AviatorUp/animation/aviatorFirstClick.json": [
		18819,
		3,
		18819
	],
	"./AviatorUp/animation/aviatorSecondClick": [
		77598,
		3,
		77598
	],
	"./AviatorUp/animation/aviatorSecondClick.json": [
		77598,
		3,
		77598
	],
	"./AviatorUp/index": [
		33537,
		9,
		11216,
		79351,
		77598,
		33537
	],
	"./AviatorUp/index.tsx": [
		33537,
		9,
		11216,
		79351,
		77598,
		33537
	],
	"./BanksBenefitsMay2025": [
		22259,
		9,
		11216,
		79351,
		22259
	],
	"./BanksBenefitsMay2025/": [
		22259,
		9,
		11216,
		79351,
		22259
	],
	"./BanksBenefitsMay2025/helpers": [
		59614,
		9,
		59614
	],
	"./BanksBenefitsMay2025/helpers.ts": [
		59614,
		9,
		59614
	],
	"./BanksBenefitsMay2025/index": [
		22259,
		9,
		11216,
		79351,
		22259
	],
	"./BanksBenefitsMay2025/index.tsx": [
		22259,
		9,
		11216,
		79351,
		22259
	],
	"./BigBass": [
		4497,
		9,
		11216,
		79351,
		4497
	],
	"./BigBass/": [
		4497,
		9,
		11216,
		79351,
		4497
	],
	"./BigBass/index": [
		4497,
		9,
		11216,
		79351,
		4497
	],
	"./BigBass/index.tsx": [
		4497,
		9,
		11216,
		79351,
		4497
	],
	"./BonusClaim": [
		28629,
		9,
		11216,
		79351,
		28629
	],
	"./BonusClaim/": [
		28629,
		9,
		11216,
		79351,
		28629
	],
	"./BonusClaim/helpers": [
		56955,
		9
	],
	"./BonusClaim/helpers.ts": [
		56955,
		9
	],
	"./BonusClaim/index": [
		28629,
		9,
		11216,
		79351,
		28629
	],
	"./BonusClaim/index.tsx": [
		28629,
		9,
		11216,
		79351,
		28629
	],
	"./BuffaloWheel": [
		47883,
		9,
		11216,
		79351,
		47883
	],
	"./BuffaloWheel/": [
		47883,
		9,
		11216,
		79351,
		47883
	],
	"./BuffaloWheel/index": [
		47883,
		9,
		11216,
		79351,
		47883
	],
	"./BuffaloWheel/index.tsx": [
		47883,
		9,
		11216,
		79351,
		47883
	],
	"./CardsBenefitsAugust2025": [
		6188,
		9,
		11216,
		79351,
		6188
	],
	"./CardsBenefitsAugust2025/": [
		6188,
		9,
		11216,
		79351,
		6188
	],
	"./CardsBenefitsAugust2025/helpers": [
		61652,
		9,
		61652
	],
	"./CardsBenefitsAugust2025/helpers.ts": [
		61652,
		9,
		61652
	],
	"./CardsBenefitsAugust2025/index": [
		6188,
		9,
		11216,
		79351,
		6188
	],
	"./CardsBenefitsAugust2025/index.tsx": [
		6188,
		9,
		11216,
		79351,
		6188
	],
	"./CardsBenefitsJune2025": [
		94231,
		9,
		11216,
		79351,
		94231
	],
	"./CardsBenefitsJune2025/": [
		94231,
		9,
		11216,
		79351,
		94231
	],
	"./CardsBenefitsJune2025/helpers": [
		35722,
		9,
		35722
	],
	"./CardsBenefitsJune2025/helpers.ts": [
		35722,
		9,
		35722
	],
	"./CardsBenefitsJune2025/index": [
		94231,
		9,
		11216,
		79351,
		94231
	],
	"./CardsBenefitsJune2025/index.tsx": [
		94231,
		9,
		11216,
		79351,
		94231
	],
	"./CardsBenefitsJune2026": [
		58120,
		9,
		11216,
		79351,
		58120
	],
	"./CardsBenefitsJune2026/": [
		58120,
		9,
		11216,
		79351,
		58120
	],
	"./CardsBenefitsJune2026/helpers": [
		33344,
		9,
		33344
	],
	"./CardsBenefitsJune2026/helpers.ts": [
		33344,
		9,
		33344
	],
	"./CardsBenefitsJune2026/index": [
		58120,
		9,
		11216,
		79351,
		58120
	],
	"./CardsBenefitsJune2026/index.tsx": [
		58120,
		9,
		11216,
		79351,
		58120
	],
	"./CardsBenefitsJune2026/styled": [
		46352,
		9,
		11216,
		79351,
		46352
	],
	"./CardsBenefitsJune2026/styled.ts": [
		46352,
		9,
		11216,
		79351,
		46352
	],
	"./CardsBenefitsMay2026": [
		3412,
		9,
		11216,
		79351,
		3412
	],
	"./CardsBenefitsMay2026/": [
		3412,
		9,
		11216,
		79351,
		3412
	],
	"./CardsBenefitsMay2026/helpers": [
		89771,
		9,
		89771
	],
	"./CardsBenefitsMay2026/helpers.ts": [
		89771,
		9,
		89771
	],
	"./CardsBenefitsMay2026/index": [
		3412,
		9,
		11216,
		79351,
		3412
	],
	"./CardsBenefitsMay2026/index.tsx": [
		3412,
		9,
		11216,
		79351,
		3412
	],
	"./CardsBenefitsMay2026/styled": [
		36095,
		9,
		11216,
		79351,
		36095
	],
	"./CardsBenefitsMay2026/styled.ts": [
		36095,
		9,
		11216,
		79351,
		36095
	],
	"./CardsBenefitsNovember2025": [
		44066,
		9,
		11216,
		79351,
		44066
	],
	"./CardsBenefitsNovember2025/": [
		44066,
		9,
		11216,
		79351,
		44066
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime": [
		44105,
		9,
		79351,
		44105
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime/": [
		44105,
		9,
		79351,
		44105
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime/index": [
		44105,
		9,
		79351,
		44105
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime/index.tsx": [
		44105,
		9,
		79351,
		44105
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime/styled": [
		21615,
		9,
		79351
	],
	"./CardsBenefitsNovember2025/components/WithdrawalTime/styled.ts": [
		21615,
		9,
		79351
	],
	"./CardsBenefitsNovember2025/index": [
		44066,
		9,
		11216,
		79351,
		44066
	],
	"./CardsBenefitsNovember2025/index.tsx": [
		44066,
		9,
		11216,
		79351,
		44066
	],
	"./CardsBenefitsNovember2025/styled": [
		29270,
		9,
		11216,
		79351,
		29270
	],
	"./CardsBenefitsNovember2025/styled.ts": [
		29270,
		9,
		11216,
		79351,
		29270
	],
	"./Carways2025": [
		5185,
		9,
		11216,
		79351,
		5185
	],
	"./Carways2025/": [
		5185,
		9,
		11216,
		79351,
		5185
	],
	"./Carways2025/index": [
		5185,
		9,
		11216,
		79351,
		5185
	],
	"./Carways2025/index.tsx": [
		5185,
		9,
		11216,
		79351,
		5185
	],
	"./Circle": [
		42174,
		9,
		11216,
		79351,
		42174
	],
	"./Circle/": [
		42174,
		9,
		11216,
		79351,
		42174
	],
	"./Circle/index": [
		42174,
		9,
		11216,
		79351,
		42174
	],
	"./Circle/index.tsx": [
		42174,
		9,
		11216,
		79351,
		42174
	],
	"./CircusNovember": [
		39210,
		9,
		11216,
		79351,
		39210
	],
	"./CircusNovember/": [
		39210,
		9,
		11216,
		79351,
		39210
	],
	"./CircusNovember/helpers": [
		3954,
		9,
		3954
	],
	"./CircusNovember/helpers.ts": [
		3954,
		9,
		3954
	],
	"./CircusNovember/index": [
		39210,
		9,
		11216,
		79351,
		39210
	],
	"./CircusNovember/index.tsx": [
		39210,
		9,
		11216,
		79351,
		39210
	],
	"./CrownBanner": [
		98280,
		9,
		11216,
		79351,
		98280
	],
	"./CrownBanner/": [
		98280,
		9,
		11216,
		79351,
		98280
	],
	"./CrownBanner/index": [
		98280,
		9,
		11216,
		79351,
		98280
	],
	"./CrownBanner/index.tsx": [
		98280,
		9,
		11216,
		79351,
		98280
	],
	"./CrownMarch25": [
		72174,
		9,
		11216,
		79351,
		72174
	],
	"./CrownMarch25/": [
		72174,
		9,
		11216,
		79351,
		72174
	],
	"./CrownMarch25/helpers": [
		77377,
		9,
		5761
	],
	"./CrownMarch25/helpers.ts": [
		77377,
		9,
		5761
	],
	"./CrownMarch25/index": [
		72174,
		9,
		11216,
		79351,
		72174
	],
	"./CrownMarch25/index.tsx": [
		72174,
		9,
		11216,
		79351,
		72174
	],
	"./CrownReg": [
		70620,
		9,
		11216,
		79351,
		70620
	],
	"./CrownReg/": [
		70620,
		9,
		11216,
		79351,
		70620
	],
	"./CrownReg/index": [
		70620,
		9,
		11216,
		79351,
		70620
	],
	"./CrownReg/index.tsx": [
		70620,
		9,
		11216,
		79351,
		70620
	],
	"./CrownWheel": [
		57600,
		9,
		11216,
		79351,
		57600
	],
	"./CrownWheel/": [
		57600,
		9,
		11216,
		79351,
		57600
	],
	"./CrownWheel/index": [
		57600,
		9,
		11216,
		79351,
		57600
	],
	"./CrownWheel/index.tsx": [
		57600,
		9,
		11216,
		79351,
		57600
	],
	"./CrownWheelBlack": [
		77680,
		9,
		11216,
		79351,
		77680
	],
	"./CrownWheelBlack/": [
		77680,
		9,
		11216,
		79351,
		77680
	],
	"./CrownWheelBlack/index": [
		77680,
		9,
		11216,
		79351,
		77680
	],
	"./CrownWheelBlack/index.tsx": [
		77680,
		9,
		11216,
		79351,
		77680
	],
	"./CrownWheelDarkReg": [
		67901,
		9,
		11216,
		79351,
		67901
	],
	"./CrownWheelDarkReg/": [
		67901,
		9,
		11216,
		79351,
		67901
	],
	"./CrownWheelDarkReg/index": [
		67901,
		9,
		11216,
		79351,
		67901
	],
	"./CrownWheelDarkReg/index.tsx": [
		67901,
		9,
		11216,
		79351,
		67901
	],
	"./CryptoExclusiveMay25": [
		79155,
		9,
		11216,
		79351,
		79155
	],
	"./CryptoExclusiveMay25/": [
		79155,
		9,
		11216,
		79351,
		79155
	],
	"./CryptoExclusiveMay25/index": [
		79155,
		9,
		11216,
		79351,
		79155
	],
	"./CryptoExclusiveMay25/index.tsx": [
		79155,
		9,
		11216,
		79351,
		79155
	],
	"./CryptoOfferMay2025": [
		95743,
		9,
		11216,
		79351,
		95743
	],
	"./CryptoOfferMay2025/": [
		95743,
		9,
		11216,
		79351,
		95743
	],
	"./CryptoOfferMay2025/index": [
		95743,
		9,
		11216,
		79351,
		95743
	],
	"./CryptoOfferMay2025/index.tsx": [
		95743,
		9,
		11216,
		79351,
		95743
	],
	"./DogTreasure": [
		66910,
		9,
		11216,
		79351,
		66910
	],
	"./DogTreasure/": [
		66910,
		9,
		11216,
		79351,
		66910
	],
	"./DogTreasure/index": [
		66910,
		9,
		11216,
		79351,
		66910
	],
	"./DogTreasure/index.tsx": [
		66910,
		9,
		11216,
		79351,
		66910
	],
	"./DogTreasureTerms": [
		51321,
		9,
		11216,
		79351,
		51321
	],
	"./DogTreasureTerms/": [
		51321,
		9,
		11216,
		79351,
		51321
	],
	"./DogTreasureTerms/index": [
		51321,
		9,
		11216,
		79351,
		51321
	],
	"./DogTreasureTerms/index.tsx": [
		51321,
		9,
		11216,
		79351,
		51321
	],
	"./DragonPearlsFebruary2026": [
		59346,
		9,
		67940,
		11216,
		79351,
		59346
	],
	"./DragonPearlsFebruary2026/": [
		59346,
		9,
		67940,
		11216,
		79351,
		59346
	],
	"./DragonPearlsFebruary2026/helpers": [
		29530,
		9,
		29530
	],
	"./DragonPearlsFebruary2026/helpers.ts": [
		29530,
		9,
		29530
	],
	"./DragonPearlsFebruary2026/index": [
		59346,
		9,
		67940,
		11216,
		79351,
		59346
	],
	"./DragonPearlsFebruary2026/index.tsx": [
		59346,
		9,
		67940,
		11216,
		79351,
		59346
	],
	"./DragonPearlsMarch2026": [
		71570,
		9,
		67940,
		11216,
		79351,
		71570
	],
	"./DragonPearlsMarch2026/": [
		71570,
		9,
		67940,
		11216,
		79351,
		71570
	],
	"./DragonPearlsMarch2026/helpers": [
		61729,
		9,
		61729
	],
	"./DragonPearlsMarch2026/helpers.ts": [
		61729,
		9,
		61729
	],
	"./DragonPearlsMarch2026/index": [
		71570,
		9,
		67940,
		11216,
		79351,
		71570
	],
	"./DragonPearlsMarch2026/index.tsx": [
		71570,
		9,
		67940,
		11216,
		79351,
		71570
	],
	"./DragonPearlsMarch2026/styled": [
		42222,
		9,
		79351,
		42222
	],
	"./DragonPearlsMarch2026/styled.ts": [
		42222,
		9,
		79351,
		42222
	],
	"./DragonPearlsNovember2025": [
		47474,
		9,
		67940,
		11216,
		79351,
		47474
	],
	"./DragonPearlsNovember2025/": [
		47474,
		9,
		67940,
		11216,
		79351,
		47474
	],
	"./DragonPearlsNovember2025/helpers": [
		71983,
		9,
		71983
	],
	"./DragonPearlsNovember2025/helpers.ts": [
		71983,
		9,
		71983
	],
	"./DragonPearlsNovember2025/index": [
		47474,
		9,
		67940,
		11216,
		79351,
		47474
	],
	"./DragonPearlsNovember2025/index.tsx": [
		47474,
		9,
		67940,
		11216,
		79351,
		47474
	],
	"./EasterApril2025": [
		54711,
		9,
		11216,
		79351,
		54711
	],
	"./EasterApril2025/": [
		54711,
		9,
		11216,
		79351,
		54711
	],
	"./EasterApril2025/index": [
		54711,
		9,
		11216,
		79351,
		54711
	],
	"./EasterApril2025/index.tsx": [
		54711,
		9,
		11216,
		79351,
		54711
	],
	"./EasterApril2026": [
		56960,
		9,
		11216,
		79351,
		56960
	],
	"./EasterApril2026/": [
		56960,
		9,
		11216,
		79351,
		56960
	],
	"./EasterApril2026/helpers": [
		16672,
		9,
		16672
	],
	"./EasterApril2026/helpers.ts": [
		16672,
		9,
		16672
	],
	"./EasterApril2026/index": [
		56960,
		9,
		11216,
		79351,
		56960
	],
	"./EasterApril2026/index.tsx": [
		56960,
		9,
		11216,
		79351,
		56960
	],
	"./FiestaJune2025": [
		2218,
		9,
		11216,
		79351,
		2218
	],
	"./FiestaJune2025/": [
		2218,
		9,
		11216,
		79351,
		2218
	],
	"./FiestaJune2025/index": [
		2218,
		9,
		11216,
		79351,
		2218
	],
	"./FiestaJune2025/index.tsx": [
		2218,
		9,
		11216,
		79351,
		2218
	],
	"./FruitCircusParty": [
		56346,
		9,
		11216,
		79351,
		56346
	],
	"./FruitCircusParty/": [
		56346,
		9,
		11216,
		79351,
		56346
	],
	"./FruitCircusParty/helpers": [
		79270,
		9,
		79270
	],
	"./FruitCircusParty/helpers.ts": [
		79270,
		9,
		79270
	],
	"./FruitCircusParty/index": [
		56346,
		9,
		11216,
		79351,
		56346
	],
	"./FruitCircusParty/index.tsx": [
		56346,
		9,
		11216,
		79351,
		56346
	],
	"./GatesOfOlympus": [
		68867,
		9,
		11216,
		79351,
		68867
	],
	"./GatesOfOlympus/": [
		68867,
		9,
		11216,
		79351,
		68867
	],
	"./GatesOfOlympus/helpers": [
		83753,
		9,
		83753
	],
	"./GatesOfOlympus/helpers.ts": [
		83753,
		9,
		83753
	],
	"./GatesOfOlympus/index": [
		68867,
		9,
		11216,
		79351,
		68867
	],
	"./GatesOfOlympus/index.tsx": [
		68867,
		9,
		11216,
		79351,
		68867
	],
	"./Halloween2026": [
		95258,
		9,
		79351,
		95258
	],
	"./Halloween2026/": [
		95258,
		9,
		79351,
		95258
	],
	"./Halloween2026/components/GamesGrid": [
		18250,
		9,
		79351,
		18250
	],
	"./Halloween2026/components/GamesGrid/": [
		18250,
		9,
		79351,
		18250
	],
	"./Halloween2026/components/GamesGrid/index": [
		18250,
		9,
		79351,
		18250
	],
	"./Halloween2026/components/GamesGrid/index.tsx": [
		18250,
		9,
		79351,
		18250
	],
	"./Halloween2026/components/GamesGrid/styled": [
		90370,
		9,
		79351
	],
	"./Halloween2026/components/GamesGrid/styled.ts": [
		90370,
		9,
		79351
	],
	"./Halloween2026/components/PaymentLogos": [
		47695,
		9,
		79351,
		47695
	],
	"./Halloween2026/components/PaymentLogos/": [
		47695,
		9,
		79351,
		47695
	],
	"./Halloween2026/components/PaymentLogos/index": [
		47695,
		9,
		79351,
		47695
	],
	"./Halloween2026/components/PaymentLogos/index.tsx": [
		47695,
		9,
		79351,
		47695
	],
	"./Halloween2026/components/PaymentLogos/styled": [
		41100,
		9,
		79351
	],
	"./Halloween2026/components/PaymentLogos/styled.ts": [
		41100,
		9,
		79351
	],
	"./Halloween2026/components/PromoCard": [
		37279,
		9,
		79351,
		37279
	],
	"./Halloween2026/components/PromoCard/": [
		37279,
		9,
		79351,
		37279
	],
	"./Halloween2026/components/PromoCard/index": [
		37279,
		9,
		79351,
		37279
	],
	"./Halloween2026/components/PromoCard/index.tsx": [
		37279,
		9,
		79351,
		37279
	],
	"./Halloween2026/components/PromoCard/styled": [
		90787,
		9,
		79351
	],
	"./Halloween2026/components/PromoCard/styled.ts": [
		90787,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField": [
		78297,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField/": [
		78297,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField/index": [
		78297,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField/index.tsx": [
		78297,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField/styled": [
		16607,
		9,
		79351
	],
	"./Halloween2026/components/PromoCodeField/styled.ts": [
		16607,
		9,
		79351
	],
	"./Halloween2026/components/TermsModal": [
		74068,
		9,
		79351,
		74068
	],
	"./Halloween2026/components/TermsModal/": [
		74068,
		9,
		79351,
		74068
	],
	"./Halloween2026/components/TermsModal/index": [
		74068,
		9,
		79351,
		74068
	],
	"./Halloween2026/components/TermsModal/index.tsx": [
		74068,
		9,
		79351,
		74068
	],
	"./Halloween2026/components/TermsModal/styled": [
		51506,
		9,
		79351
	],
	"./Halloween2026/components/TermsModal/styled.ts": [
		51506,
		9,
		79351
	],
	"./Halloween2026/components/VipBonuses": [
		21684,
		9,
		79351,
		21684
	],
	"./Halloween2026/components/VipBonuses/": [
		21684,
		9,
		79351,
		21684
	],
	"./Halloween2026/components/VipBonuses/index": [
		21684,
		9,
		79351,
		21684
	],
	"./Halloween2026/components/VipBonuses/index.tsx": [
		21684,
		9,
		79351,
		21684
	],
	"./Halloween2026/components/VipBonuses/styled": [
		88556,
		9,
		79351
	],
	"./Halloween2026/components/VipBonuses/styled.ts": [
		88556,
		9,
		79351
	],
	"./Halloween2026/helpers": [
		30919,
		9,
		79351
	],
	"./Halloween2026/helpers.ts": [
		30919,
		9,
		79351
	],
	"./Halloween2026/hooks/useHalloweenRegBanner": [
		95693,
		9,
		79351,
		95693
	],
	"./Halloween2026/hooks/useHalloweenRegBanner.ts": [
		95693,
		9,
		79351,
		95693
	],
	"./Halloween2026/index": [
		95258,
		9,
		79351,
		95258
	],
	"./Halloween2026/index.tsx": [
		95258,
		9,
		79351,
		95258
	],
	"./Halloween2026/styled": [
		56088,
		9,
		79351
	],
	"./Halloween2026/styled.ts": [
		56088,
		9,
		79351
	],
	"./JuicyCarMay2025": [
		58523,
		9,
		11216,
		79351,
		58523
	],
	"./JuicyCarMay2025/": [
		58523,
		9,
		11216,
		79351,
		58523
	],
	"./JuicyCarMay2025/index": [
		58523,
		9,
		11216,
		79351,
		58523
	],
	"./JuicyCarMay2025/index.tsx": [
		58523,
		9,
		11216,
		79351,
		58523
	],
	"./Oktoberfest2026": [
		25738,
		9,
		11216,
		79351,
		25738
	],
	"./Oktoberfest2026/": [
		25738,
		9,
		11216,
		79351,
		25738
	],
	"./Oktoberfest2026/components/GameCard": [
		80042,
		9,
		79351,
		80042
	],
	"./Oktoberfest2026/components/GameCard/": [
		80042,
		9,
		79351,
		80042
	],
	"./Oktoberfest2026/components/GameCard/index": [
		80042,
		9,
		79351,
		80042
	],
	"./Oktoberfest2026/components/GameCard/index.tsx": [
		80042,
		9,
		79351,
		80042
	],
	"./Oktoberfest2026/components/GameCard/styled": [
		13901,
		9,
		79351
	],
	"./Oktoberfest2026/components/GameCard/styled.ts": [
		13901,
		9,
		79351
	],
	"./Oktoberfest2026/helpers": [
		44001,
		9,
		44001
	],
	"./Oktoberfest2026/helpers.ts": [
		44001,
		9,
		44001
	],
	"./Oktoberfest2026/index": [
		25738,
		9,
		11216,
		79351,
		25738
	],
	"./Oktoberfest2026/index.tsx": [
		25738,
		9,
		11216,
		79351,
		25738
	],
	"./Oktoberfest2026/styled": [
		55440,
		9,
		11216,
		79351,
		55440
	],
	"./Oktoberfest2026/styled.ts": [
		55440,
		9,
		11216,
		79351,
		55440
	],
	"./QuizBonusJune2025": [
		97111,
		9,
		11216,
		79351,
		97111
	],
	"./QuizBonusJune2025/": [
		97111,
		9,
		11216,
		79351,
		97111
	],
	"./QuizBonusJune2025/index": [
		97111,
		9,
		11216,
		79351,
		97111
	],
	"./QuizBonusJune2025/index.tsx": [
		97111,
		9,
		11216,
		79351,
		97111
	],
	"./RegDragonRewards": [
		94513,
		9,
		11216,
		79351,
		94513
	],
	"./RegDragonRewards/": [
		94513,
		9,
		11216,
		79351,
		94513
	],
	"./RegDragonRewards/helpers": [
		79927,
		9,
		79927
	],
	"./RegDragonRewards/helpers.ts": [
		79927,
		9,
		79927
	],
	"./RegDragonRewards/index": [
		94513,
		9,
		11216,
		79351,
		94513
	],
	"./RegDragonRewards/index.tsx": [
		94513,
		9,
		11216,
		79351,
		94513
	],
	"./RegDragonRewards/styled": [
		78481,
		9,
		79351,
		78481
	],
	"./RegDragonRewards/styled.ts": [
		78481,
		9,
		79351,
		78481
	],
	"./RegRewards": [
		34347,
		9,
		11216,
		79351,
		34347
	],
	"./RegRewards/": [
		34347,
		9,
		11216,
		79351,
		34347
	],
	"./RegRewards/index": [
		34347,
		9,
		11216,
		79351,
		34347
	],
	"./RegRewards/index.tsx": [
		34347,
		9,
		11216,
		79351,
		34347
	],
	"./SharkJuly25": [
		21309,
		9,
		11216,
		79351,
		21309
	],
	"./SharkJuly25/": [
		21309,
		9,
		11216,
		79351,
		21309
	],
	"./SharkJuly25/helpers": [
		62864,
		9,
		62864
	],
	"./SharkJuly25/helpers.ts": [
		62864,
		9,
		62864
	],
	"./SharkJuly25/index": [
		21309,
		9,
		11216,
		79351,
		21309
	],
	"./SharkJuly25/index.tsx": [
		21309,
		9,
		11216,
		79351,
		21309
	],
	"./SlotMachineSeptember26": [
		37722,
		9,
		11216,
		79351,
		37722
	],
	"./SlotMachineSeptember26/": [
		37722,
		9,
		11216,
		79351,
		37722
	],
	"./SlotMachineSeptember26/components/FirstStageOffer": [
		29450,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/FirstStageOffer/": [
		29450,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/FirstStageOffer/index": [
		29450,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/FirstStageOffer/index.tsx": [
		29450,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/FirstStageOffer/styled": [
		4707,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/FirstStageOffer/styled.ts": [
		4707,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/OfferCard": [
		18488,
		9,
		11216,
		79351,
		18488
	],
	"./SlotMachineSeptember26/components/OfferCard/": [
		18488,
		9,
		11216,
		79351,
		18488
	],
	"./SlotMachineSeptember26/components/OfferCard/index": [
		18488,
		9,
		11216,
		79351,
		18488
	],
	"./SlotMachineSeptember26/components/OfferCard/index.tsx": [
		18488,
		9,
		11216,
		79351,
		18488
	],
	"./SlotMachineSeptember26/components/OfferCard/styled": [
		36674,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/OfferCard/styled.ts": [
		36674,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer": [
		49623,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer/": [
		49623,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer/index": [
		49623,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer/index.tsx": [
		49623,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer/styled": [
		73983,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/SecondStageOffer/styled.ts": [
		73983,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack": [
		75182,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack/": [
		75182,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack/index": [
		75182,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack/index.tsx": [
		75182,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack/styled": [
		57417,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/TermsBack/styled.ts": [
		57417,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer": [
		25775,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer/": [
		25775,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer/index": [
		25775,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer/index.tsx": [
		25775,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer/styled": [
		10181,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/ThirdStageOffer/styled.ts": [
		10181,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo": [
		50226,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo/": [
		50226,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo/index": [
		50226,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo/index.tsx": [
		50226,
		9,
		11216,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo/styled": [
		21027,
		9,
		79351
	],
	"./SlotMachineSeptember26/components/WinInfo/styled.ts": [
		21027,
		9,
		79351
	],
	"./SlotMachineSeptember26/helpers": [
		18748,
		9,
		79351
	],
	"./SlotMachineSeptember26/helpers.ts": [
		18748,
		9,
		79351
	],
	"./SlotMachineSeptember26/hooks": [
		39431,
		9,
		79351,
		39431
	],
	"./SlotMachineSeptember26/hooks/": [
		39431,
		9,
		79351,
		39431
	],
	"./SlotMachineSeptember26/hooks/index": [
		39431,
		9,
		79351,
		39431
	],
	"./SlotMachineSeptember26/hooks/index.ts": [
		39431,
		9,
		79351,
		39431
	],
	"./SlotMachineSeptember26/hooks/useFinalOfferOnRegModalClose": [
		39178,
		9,
		79351
	],
	"./SlotMachineSeptember26/hooks/useFinalOfferOnRegModalClose.ts": [
		39178,
		9,
		79351
	],
	"./SlotMachineSeptember26/hooks/useOfferReveal": [
		65695,
		9,
		79351
	],
	"./SlotMachineSeptember26/hooks/useOfferReveal.ts": [
		65695,
		9,
		79351
	],
	"./SlotMachineSeptember26/index": [
		37722,
		9,
		11216,
		79351,
		37722
	],
	"./SlotMachineSeptember26/index.tsx": [
		37722,
		9,
		11216,
		79351,
		37722
	],
	"./SlotMachineSeptember26/styled": [
		52267,
		9,
		79351,
		52267
	],
	"./SlotMachineSeptember26/styled.ts": [
		52267,
		9,
		79351,
		52267
	],
	"./SlotsCircle": [
		71534,
		9,
		79351,
		86041
	],
	"./SlotsCircle/": [
		71534,
		9,
		79351,
		86041
	],
	"./SlotsCircle/index": [
		71534,
		9,
		79351,
		86041
	],
	"./SlotsCircle/index.tsx": [
		71534,
		9,
		79351,
		86041
	],
	"./SlotsStepsAugust2025": [
		48938,
		9,
		11216,
		79351,
		48938
	],
	"./SlotsStepsAugust2025/": [
		48938,
		9,
		11216,
		79351,
		48938
	],
	"./SlotsStepsAugust2025/index": [
		48938,
		9,
		11216,
		79351,
		48938
	],
	"./SlotsStepsAugust2025/index.tsx": [
		48938,
		9,
		11216,
		79351,
		48938
	],
	"./SlotsStepsAugust2025/styled": [
		34395,
		9,
		79351,
		34395
	],
	"./SlotsStepsAugust2025/styled.ts": [
		34395,
		9,
		79351,
		34395
	],
	"./StPatrick2026": [
		40368,
		9,
		11216,
		79351,
		40368
	],
	"./StPatrick2026/": [
		40368,
		9,
		11216,
		79351,
		40368
	],
	"./StPatrick2026/helpers": [
		53126,
		9,
		53126
	],
	"./StPatrick2026/helpers.ts": [
		53126,
		9,
		53126
	],
	"./StPatrick2026/index": [
		40368,
		9,
		11216,
		79351,
		40368
	],
	"./StPatrick2026/index.tsx": [
		40368,
		9,
		11216,
		79351,
		40368
	],
	"./StPatrick2026/styled": [
		52430,
		9,
		11216,
		79351,
		52430
	],
	"./StPatrick2026/styled.ts": [
		52430,
		9,
		11216,
		79351,
		52430
	],
	"./StValentine2026": [
		93540,
		9,
		11216,
		79351,
		93540
	],
	"./StValentine2026/": [
		93540,
		9,
		11216,
		79351,
		93540
	],
	"./StValentine2026/helpers": [
		72647,
		9,
		72647
	],
	"./StValentine2026/helpers.ts": [
		72647,
		9,
		72647
	],
	"./StValentine2026/index": [
		93540,
		9,
		11216,
		79351,
		93540
	],
	"./StValentine2026/index.tsx": [
		93540,
		9,
		11216,
		79351,
		93540
	],
	"./StValentine2026/styled": [
		99188,
		9,
		11216,
		79351,
		99188
	],
	"./StValentine2026/styled.ts": [
		99188,
		9,
		11216,
		79351,
		99188
	],
	"./StarGoldCoast": [
		48301,
		9,
		11216,
		79351,
		48301
	],
	"./StarGoldCoast/": [
		48301,
		9,
		11216,
		79351,
		48301
	],
	"./StarGoldCoast/index": [
		48301,
		9,
		11216,
		79351,
		48301
	],
	"./StarGoldCoast/index.tsx": [
		48301,
		9,
		11216,
		79351,
		48301
	],
	"./SunOfEgypt": [
		39623,
		9,
		11216,
		79351,
		39623
	],
	"./SunOfEgypt/": [
		39623,
		9,
		11216,
		79351,
		39623
	],
	"./SunOfEgypt/index": [
		39623,
		9,
		11216,
		79351,
		39623
	],
	"./SunOfEgypt/index.tsx": [
		39623,
		9,
		11216,
		79351,
		39623
	],
	"./TopGamesBanksBenefitsOctober2025": [
		29597,
		9,
		11216,
		79351,
		29597
	],
	"./TopGamesBanksBenefitsOctober2025/": [
		29597,
		9,
		11216,
		79351,
		29597
	],
	"./TopGamesBanksBenefitsOctober2025/helpers": [
		31965,
		9,
		31965
	],
	"./TopGamesBanksBenefitsOctober2025/helpers.ts": [
		31965,
		9,
		31965
	],
	"./TopGamesBanksBenefitsOctober2025/index": [
		29597,
		9,
		11216,
		79351,
		29597
	],
	"./TopGamesBanksBenefitsOctober2025/index.tsx": [
		29597,
		9,
		11216,
		79351,
		29597
	],
	"./WelcomeApril2025": [
		83055,
		9,
		11216,
		79351,
		83055
	],
	"./WelcomeApril2025/": [
		83055,
		9,
		11216,
		79351,
		83055
	],
	"./WelcomeApril2025/helpers": [
		60476,
		9
	],
	"./WelcomeApril2025/helpers.ts": [
		60476,
		9
	],
	"./WelcomeApril2025/index": [
		83055,
		9,
		11216,
		79351,
		83055
	],
	"./WelcomeApril2025/index.tsx": [
		83055,
		9,
		11216,
		79351,
		83055
	],
	"./WheelFortune": [
		38609,
		9,
		11216,
		79351,
		38609
	],
	"./WheelFortune/": [
		38609,
		9,
		11216,
		79351,
		38609
	],
	"./WheelFortune/index": [
		38609,
		9,
		11216,
		79351,
		38609
	],
	"./WheelFortune/index.tsx": [
		38609,
		9,
		11216,
		79351,
		38609
	],
	"./WinterJanuary": [
		30207,
		9,
		11216,
		79351,
		30207
	],
	"./WinterJanuary/": [
		30207,
		9,
		11216,
		79351,
		30207
	],
	"./WinterJanuary/index": [
		30207,
		9,
		11216,
		79351,
		30207
	],
	"./WinterJanuary/index.tsx": [
		30207,
		9,
		11216,
		79351,
		30207
	],
	"./WolfElvisSunBuffalo": [
		83087,
		9,
		11216,
		79351,
		83087
	],
	"./WolfElvisSunBuffalo/": [
		83087,
		9,
		11216,
		79351,
		83087
	],
	"./WolfElvisSunBuffalo/index": [
		83087,
		9,
		11216,
		79351,
		83087
	],
	"./WolfElvisSunBuffalo/index.tsx": [
		83087,
		9,
		11216,
		79351,
		83087
	],
	"./WolfWheel": [
		64260,
		9,
		11216,
		79351,
		64260
	],
	"./WolfWheel/": [
		64260,
		9,
		11216,
		79351,
		64260
	],
	"./WolfWheel/index": [
		64260,
		9,
		11216,
		79351,
		64260
	],
	"./WolfWheel/index.tsx": [
		64260,
		9,
		11216,
		79351,
		64260
	],
	"./XmasJanuary2026": [
		7704,
		9,
		11216,
		79351,
		7704
	],
	"./XmasJanuary2026/": [
		7704,
		9,
		11216,
		79351,
		7704
	],
	"./XmasJanuary2026/helpers": [
		88503,
		9,
		88503
	],
	"./XmasJanuary2026/helpers.ts": [
		88503,
		9,
		88503
	],
	"./XmasJanuary2026/index": [
		7704,
		9,
		11216,
		79351,
		7704
	],
	"./XmasJanuary2026/index.tsx": [
		7704,
		9,
		11216,
		79351,
		7704
	],
	"./XmasJanuary2026/styled": [
		13063,
		9,
		11216,
		79351,
		14757
	],
	"./XmasJanuary2026/styled.ts": [
		13063,
		9,
		11216,
		79351,
		14757
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 63687;
module.exports = webpackAsyncContext;